import {createEffectFn} from '@ngneat/effects';
import {catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap} from 'rxjs';
import {invoicesService} from '@store/invoices/invoices/invoices.service';
import {InvoicesState} from '@store/invoices/invoices/invoices.store';

type SearchInvoicesParams = Partial<InvoicesState>

export const searchInvoicesEffect = createEffectFn((params$: Observable<SearchInvoicesParams>) => {
  return params$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(() => invoicesService.getInvoices().pipe(catchError(() => EMPTY))),
  );
});
